import { Component, OnInit, ViewChild } from '@angular/core';
import {
  FormGroupDirective,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import * as cloneDeep from 'lodash/cloneDeep';
import * as Moment from 'moment';
import { extendMoment } from 'moment-range';
import { SiteModel, SiteStepperModel } from 'src/app/models/index';
import {
  CommonService,
  SiteService,
  SiteStepperService
} from 'src/app/services/index';
import { SiteStepperEnum } from 'src/app/shared';
import { AlertService, DateService } from 'src/app/shared/index';

export interface ShiftDetail {
  shiftId: string;
  shiftStart: any;
  shiftEnd: any;
  shiftName: string;
}

@Component({
  selector: 'app-shift-details',
  templateUrl: './shift-details.component.html',
  styleUrls: ['./shift-details.component.scss']
})
export class ShiftDetailsComponent implements OnInit {
  @ViewChild('formDirective') formDirective: FormGroupDirective;
  formdata: UntypedFormGroup;
  displayedColumns = [
    'shiftId',
    'shiftName',
    'shiftStart',
    'shiftEnd',
    'actions'
  ];
  siteId: string;
  maxNoOfShift = 4;
  shifts = [];
  formControlIndex = [];
  indexCount = 0;

  moment = extendMoment(Moment);
  dataSource: MatTableDataSource<ShiftDetail>;
  isOverlapShiftTime = true;
  isDuplicatedShiftId = true;
  isDuplicatedShiftName = true;
  isShiftStartTimePresent = false;
  isShiftEndTimePresent = false;
  time: any;
  siteModel: SiteModel;
  public timeValue1: UntypedFormControl = new UntypedFormControl();
  public timeValue2: UntypedFormControl = new UntypedFormControl();
  constructor(
    private alertService: AlertService,
    private fb: UntypedFormBuilder,
    private activeRoute: ActivatedRoute,
    private siteService: SiteService,
    private dateService: DateService,
    private siteStepperService: SiteStepperService,
    private commonService: CommonService
  ) {}

  ngOnInit() {
    this.formdata = this.fb.group({
      index: [
        '',
        [
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(250)
        ]
      ]
    });

    this.initFirstShift();
    this.siteModel = new SiteModel();
    this.siteStepperService.getStepperSubject().subscribe((data) => {
      if (
        data.selectedIndex === SiteStepperEnum.ShiftDetails &&
        !this.commonService.isNullOrUndefined(data.siteModel)
      ) {
        this.siteId = data.siteModel.siteId;
        this.siteModel = data.siteModel;
        this.loadShifts(this.siteId);
      }
    });
  }

  loadShifts(siteId) {
    this.siteService.getShiftsBySiteId(siteId).subscribe((data) => {
      if (data.length > 0) {
        this.formControlIndex = [];
        this.shifts = [];

        this.time = new Date(data[0].shiftStart);
        for (let i = 0; i < data.length; i++) {
          const shift: ShiftDetail = {
            shiftId: this.commonService.isNullOrUndefined(data[i].shiftId)
              ? ''
              : data[i].shiftId,
            shiftStart: new Date(data[i].shiftStart),
            shiftEnd: new Date(data[i].shiftEnd),
            shiftName: data[i].shiftName
          };
          this.shifts.push(shift);
          this.initFormControls(i);
        }
        this.indexCount = this.shifts.length;
        this.dataSource = new MatTableDataSource<ShiftDetail>(this.shifts);
        this.validateInput();
        this.isFormValid();
      }
      this.isOverlapShiftTime = false;
      this.isDuplicatedShiftId = false;
      this.isDuplicatedShiftName = false;
    });
  }

  formatTwoNumber(n) {
    return n > 9 ? '' + n : '0' + n;
  }

  initFirstShift() {
    this.initFormControls(0);

    this.shifts = [this.initShift()];
    this.dataSource = new MatTableDataSource<ShiftDetail>(this.shifts);
    this.isOverlapShiftTime = false;
    this.isDuplicatedShiftId = false;
    this.isDuplicatedShiftName = false;
  }

  initShift() {
    return {
      shiftId: '',
      shiftName: '',
      shiftStart: new Date(1970, 1, 1, 0, 0, 0),
      shiftEnd: new Date(1970, 1, 1, 0, 1, 0)
    };
  }

  clear(index) {
    this.shifts[index] = this.initShift();
    this.dataSource = new MatTableDataSource<ShiftDetail>(this.shifts);

    this.validateInput();
  }

  remove(index) {
    // Clear controls
    const formIndex = this.formControlIndex[index];
    const shiftNameControl = 'shiftName' + formIndex;
    this.formdata.removeControl(shiftNameControl);
    const shiftIdControl = 'shiftId' + formIndex;
    this.formdata.removeControl(shiftIdControl);

    this.shifts.splice(index, 1);
    this.formControlIndex.splice(index, 1);
    this.dataSource = new MatTableDataSource<ShiftDetail>(this.shifts);

    const shiftStartControl = 'shiftStart' + formIndex;
    this.formdata.removeControl(shiftStartControl);
    const shiftEndControl = 'shiftEnd' + formIndex;
    this.formdata.removeControl(shiftEndControl);

    let formdataVal = this.formdata.value;
    for (let i = formIndex; i >= 0; i--) {
      if (formdataVal['shiftEnd' + i] != undefined) {
        if (formdataVal['shiftEnd' + i] != '') {
          console.log(formdataVal['shiftEnd' + i]);
        } else {
          this.isShiftEndTimePresent = true;
        }
      } else {
        console.log(formdataVal['shiftEnd' + i]);
      }

      if (formdataVal['shiftStart' + i] != undefined) {
        if (formdataVal['shiftStart' + i] != '') {
          console.log(formdataVal['shiftStart' + i]);
        } else {
          this.isShiftStartTimePresent = true;
        }
      } else {
        console.log(formdataVal['shiftStart' + i]);
      }
    }

    this.validateInput();
  }

  add() {
    this.indexCount = this.indexCount + 1;
    this.shifts.push(this.initShift());
    this.initFormControls(this.indexCount);
    this.dataSource = new MatTableDataSource<ShiftDetail>(this.shifts);

    this.validateInput();
  }

  validateTimeSlotsShiftStart(event, index) {
    const val = event.target.value;
    const splitHour = val.split(':');
    const found = this.shifts[index];
    if (found) {
      // Set hours
      if (splitHour != '') {
        this.isShiftStartTimePresent = false;

        if (splitHour[0] != null) {
          found.shiftStart.setHours(splitHour[0]);
        }
        // Then set minutes
        if (splitHour[1] != null) {
          found.shiftStart.setMinutes(splitHour[1]);
        }
        // Then set seconds
        if (splitHour[2] != null) {
          found.shiftStart.setSeconds(splitHour[2]);
        }
      } else {
        // found.shiftStart = "";
        this.isShiftStartTimePresent = true;
        // console.log("found in else : ",found)
      }
    }
    this.isOverlapShiftTime = this.isOverlapTime();
  }

  validateTimeSlotsShiftEnd(event, index) {
    const val = event.target.value;
    const splitHour = val.split(':');
    const found = this.shifts[index];
    if (found) {
      // Set hours
      if (splitHour != '') {
        this.isShiftEndTimePresent = false;

        if (splitHour[0] != null) {
          found.shiftEnd.setHours(splitHour[0]);
        }
        // Then set minutes
        if (splitHour[1] != null) {
          found.shiftEnd.setMinutes(splitHour[1]);
        }
        // Then set seconds
        if (splitHour[2] != null) {
          found.shiftEnd.setSeconds(splitHour[2]);
        }
      } else {
        // found.shiftStart = "";
        this.isShiftEndTimePresent = true;
        // console.log("found in else : ",found)
      }
    }

    this.isOverlapShiftTime = this.isOverlapTime();
  }

  isOverlapTime() {
    const result = false;
    const timeRanges = Object.assign([], this.shifts);

    if (timeRanges.length < 2) {
      return false;
    }

    for (let i = 0; i < timeRanges.length - 1; i++) {
      for (let j = i + 1; j < timeRanges.length; j++) {
        let isAdded1 = false;
        let isAdded2 = false;
        let start1 = new Date(timeRanges[i].shiftStart);
        let end1 = new Date(timeRanges[i].shiftEnd);
        if (start1 > end1) {
          end1 = this.addDay(timeRanges[i].shiftEnd, 1);
          isAdded1 = true;
        }
        let start2 = new Date(timeRanges[j].shiftStart);
        let end2 = new Date(timeRanges[j].shiftEnd);
        if (start2 > end2) {
          end2 = this.addDay(timeRanges[j].shiftEnd, 1);
          isAdded2 = true;
        }

        if (isAdded1 && !isAdded2) {
          start2 = this.addDay(timeRanges[j].shiftStart, 1);
          end2 = this.addDay(timeRanges[j].shiftEnd, 1);
        }
        if (!isAdded1 && isAdded2) {
          start1 = this.addDay(timeRanges[i].shiftStart, 1);
          end1 = this.addDay(timeRanges[i].shiftEnd, 1);
        }

        const range1 = this.moment.range(start1, end1);
        const range2 = this.moment.range(start2, end2);
        if (range1.overlaps(range2, { adjacent: true })) {
          return true;
        }
      }
    }

    return result;
  }

  addDay(dateString, addToDays) {
    const date = new Date(dateString);
    date.setDate(date.getDate() + addToDays);
    return date;
  }

  public previousStep = (event: any) => {
    event.preventDefault();
    this.siteStepperService.setSendStepper(true);
    this.siteStepperService.sendStepperSubject(
      new SiteStepperModel(SiteStepperEnum.ConnectionDetails, this.siteModel)
    );
  };

  nextStep = (event: any) => {
    event.preventDefault();
    this.siteStepperService.setSendStepper(true);
    this.siteStepperService.sendStepperSubject(
      new SiteStepperModel(
        SiteStepperEnum.ProcessAndLoadDetails,
        this.siteModel
      )
    );
  };

  submitShifts() {
    const t = this;

    const shiftsToSubmit = cloneDeep(this.shifts);
    t.siteService.saveShifts(shiftsToSubmit, t.siteId).subscribe((response) => {
      if (!this.commonService.isNullOrUndefined(response)) {
        this.alertService.message = 'Saved Successfully';
        this.alertService.showSuccess(this.alertService.message);
      } else {
        this.alertService.message = 'Failure in saving the data!';
        this.alertService.showError(this.alertService.message);
      }
    });
  }

  private initFormControls(index: number) {
    this.formControlIndex.push(index);

    const shiftNameControl = 'shiftName' + index;

    if (
      this.commonService.isNullOrUndefined(this.formdata.get(shiftNameControl))
    ) {
      this.formdata.addControl(
        shiftNameControl,
        new UntypedFormControl('', [
          Validators.required,
          Validators.maxLength(50),
          Validators.pattern('[a-zA-Z0-9_& ./:,-]*'),
          this.startWhitespace
        ])
      );
    }

    const shiftIdControl = 'shiftId' + index;
    if (
      this.commonService.isNullOrUndefined(this.formdata.get(shiftIdControl))
    ) {
      this.formdata.addControl(
        shiftIdControl,
        new UntypedFormControl('', Validators.required)
      );
    }

    const shiftStartControl = 'shiftStart' + index;
    if (
      this.commonService.isNullOrUndefined(this.formdata.get(shiftStartControl))
    ) {
      this.formdata.addControl(
        shiftStartControl,
        new UntypedFormControl(new Date(), Validators.required)
      );
    }

    const shiftEndControl = 'shiftEnd' + index;
    if (
      this.commonService.isNullOrUndefined(this.formdata.get(shiftEndControl))
    ) {
      this.formdata.addControl(
        shiftEndControl,
        new UntypedFormControl(new Date(), Validators.required)
      );
    }
  }

  validateShiftId() {
    this.isDuplicatedShiftId = this.isDuplicateShiftId();
  }

  isDuplicateShiftId() {
    let isDuplicated = false;
    if (this.shifts.length > 1) {
      for (let i = 0; i < this.shifts.length - 1; i++) {
        for (let j = i + 1; j < this.shifts.length; j++) {
          if (
            this.shifts[i].shiftId.toString() ===
            this.shifts[j].shiftId.toString()
          ) {
            isDuplicated = true;
            break;
          }
        }
        if (isDuplicated) {
          break;
        }
      }
    }
    return isDuplicated;
  }

  validateShiftName() {
    this.isDuplicatedShiftName = this.isDuplicateShiftName();
  }

  isDuplicateShiftName() {
    let isDuplicated = false;
    if (this.shifts.length > 1) {
      for (let i = 0; i < this.shifts.length - 1; i++) {
        for (let j = i + 1; j < this.shifts.length; j++) {
          if (
            this.shifts[i].shiftName.toString() ===
            this.shifts[j].shiftName.toString()
          ) {
            isDuplicated = true;
            break;
          }
        }
        if (isDuplicated) {
          break;
        }
      }
    }
    return isDuplicated;
  }

  private validateInput() {
    this.isDuplicatedShiftId = this.isDuplicateShiftId();
    this.isDuplicatedShiftName = this.isDuplicateShiftName();
    this.isOverlapShiftTime = this.isOverlapTime();
  }

  isFormValid() {
    if (this.isDuplicatedShiftId) {
      return false;
    }

    if (this.isDuplicatedShiftName) {
      return false;
    }

    if (this.isOverlapShiftTime) {
      return false;
    }

    if (this.isShiftStartTimePresent) {
      return false;
    }

    if (this.isShiftEndTimePresent) {
      return false;
    }

    let isEmptyShiftName = false;
    let isEmptyShiftId = false;
    for (let i = 0; i < this.shifts.length; i++) {
      // Check Shift Id
      if (
        this.commonService.isNullOrUndefined(this.shifts[i].shiftId) ||
        this.shifts[i].shiftId === ''
      ) {
        isEmptyShiftId = true;
        break;
      }
      // Check Shift Name
      if (
        this.commonService.isNullOrUndefined(this.shifts[i].shiftName) ||
        this.shifts[i].shiftName === ''
      ) {
        isEmptyShiftName = true;
        break;
      }
    }
    if (isEmptyShiftName || isEmptyShiftId) {
      return false;
    }

    return true;
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  isFieldHasError({
    controlName,
    index,
    error
  }: {
    controlName: string;
    index: number;
    error: string;
  }): boolean {
    const idx = this.formControlIndex[index];
    const name = `${controlName}${idx}`;
    return this.formdata.controls[name].hasError(error);
  }

  public startWhitespace(control: UntypedFormControl) {
    if (
      (control.value as string) &&
      (control.value as string).indexOf(' ') == 0
    ) {
      return { whitespace: true };
    }
    return null;
  }
}
